module.exports = __webpack_public_path__ + "img/Slice 268@2x(7).8326a03c.png";